import { useMutation } from '@tanstack/react-query';
import { deleteVirtualMedicine } from '../requests';

type DeleteVirtualMedicine = (id: string) => Promise<void>;

interface UseDeleteVirtualMedicineReturn {
  deleteVirtualMedicine: DeleteVirtualMedicine;
  isLoading: boolean;
}

export const useDeleteVirtualMedicine = (): UseDeleteVirtualMedicineReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (id: string) => deleteVirtualMedicine(id)
  });

  const deleteVirtualMedicineCallback = async (id: string) => {
    const response = await mutateAsync(id);
    return response.data.data;
  };

  return {
    deleteVirtualMedicine: deleteVirtualMedicineCallback,
    isLoading
  };
};
